import React, { useState, useEffect } from "react";
import {
  AccordionDetails,
  AccordionSummary,
  Typography,
  Button,
  TextField,
  Box,
  Accordion,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TypeAutoComplete from "../../basic-information/productType/TypeAutoComplete";
import MaterialAutoComplete from "../../basic-information/productMaterial/MaterialAutoComplete";
import SizeAutoComplete from "../../basic-information/productSize/SizeAutoComplete";
import ColorAutoComplete from "../../basic-information/productColor/ColorAutoComplete";
import TasteAutoComplete from "../../basic-information/productTaste/TasteAutoComplete";
import ScentAutoComplete from "../../basic-information/smell/ScentAutoComplete";
import ShieldAutoComplete from "../../basic-information/productShield/ShieldAutoComplete";
import { UseProduct } from "./UseProduct";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function EditLevel2(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { validateLvl2Edit } = UseProduct();
  const [open, setOpen] = useState(false);
  const [level2, setLevel2] = React.useState({
    countInPack: props.product.countInPack,
    consumerAge: props.product.consumerAge,
    weight: props.product.weight,
    typeID: props.product.typeID ? props.product.typeID : 0,
    materialID: props.product.materialID,
    sizeID: props.product.sizeID,
    colorID: props.product.colorID,
    tasteID: props.product.tasteID,
    scentID: props.product.scentID,
    shieldID: props.product.shieldID,
  });
  const { isSmall } = useBreakpoints();

  const [stateValidation, setStateValidation] = useState({
    typeID: false,
    weight: false,
  });

  useEffect(() => {
    if (props.fire) {
      Validation2();
    }
  }, [props.fire]);

  return (
    <Accordion
      expanded={props.expanded === "panel2"}
      style={{ margin: "20px", paddingBottom: "15px" }}
    >
      <AccordionSummary
        onClick={() => props.setExpanded("panel2")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography sx={{ width: "33%", flexShrink: 0 }}>مرحله دوم</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Dialog
          PaperProps={{
            elevation: 1,
          }}
          fullWidth
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle color="red" id="alert-dialog-title">
            توجه!
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              آیا از اتمام ویرایش محصول اطمینان دارید ؟
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{ color: "#565656 !important" }}
              onClick={() => props.setFire(true)}
            >
              بله
            </Button>
            <Button color="secondary" onClick={() => setOpen(false)}>
              خیر
            </Button>
          </DialogActions>
        </Dialog>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TypeAutoComplete
              selectedTypeID={level2.typeID}
              validation={stateValidation.typeID}
              setter={setLevel2}
              lvl2State={level2}
            ></TypeAutoComplete>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <MaterialAutoComplete
              selectedMaterialID={level2.materialID}
              setter={setLevel2}
              lvl2State={level2}
            ></MaterialAutoComplete>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <SizeAutoComplete
              selectedSizeID={level2.sizeID}
              setter={setLevel2}
              lvl2State={level2}
            ></SizeAutoComplete>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <ColorAutoComplete
              selectedColorID={level2.colorID}
              setter={setLevel2}
              lvl2State={level2}
            ></ColorAutoComplete>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TasteAutoComplete
              selectedTasteID={level2.tasteID}
              setter={setLevel2}
              lvl2State={level2}
            ></TasteAutoComplete>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <ScentAutoComplete
              selectedScentID={level2.scentID}
              setter={setLevel2}
              lvl2State={level2}
            ></ScentAutoComplete>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <ShieldAutoComplete
              selectedShieldID={level2.shieldID}
              setter={setLevel2}
              lvl2State={level2}
            ></ShieldAutoComplete>
          </Box>

          {!isSmall && <Box gridColumn="span 3"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 2"}>
            <TextField
              type="number"
              size="small"
              id="outlined-basic"
              value={level2.countInPack ? level2.countInPack : ""}
              label=" تعداد در بسته "
              variant="outlined"
              onChange={(event) => {
                if (event.target.value) {
                  setLevel2({
                    ...level2,
                    countInPack: event.target.value,
                  });
                } else {
                  setLevel2({
                    ...level2,
                    countInPack: null,
                  });
                }
              }}
              fullWidth
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 2"}>
            <TextField
              type="number"
              size="small"
              id="outlined-basic"
              value={level2.weight ? level2.weight : ""}
              error={stateValidation.weight}
              label="وزن"
              variant="outlined"
              onChange={(event) => {
                setLevel2({
                  ...level2,
                  weight: event.target.value,
                });
              }}
              fullWidth
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 2"}>
            <TextField
              size="small"
              id="outlined-basic"
              value={level2.consumerAge ? level2.consumerAge : ""}
              label="سن مصرف"
              variant="outlined"
              onChange={(event) => {
                setLevel2({
                  ...level2,
                  consumerAge: event.target.value,
                });
              }}
              fullWidth
            />
          </Box>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="outlined"
            color="secondary"
            onClick={() => props.setExpanded("panel1")}
          >
            مرحله قبل
          </Button>
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            onClick={() => setOpen(true)}
          >
            اتمام
          </Button>
          <Button
            sx={{ width: "100px" }}
            variant="contained"
            color="secondary"
            onClick={() => Validation2()}
          >
            مرحله بعد
          </Button>
        </Box>
      </AccordionDetails>
    </Accordion>
  );

  function Validation2() {
    validateLvl2Edit(
      level2,
      setStateValidation,
      (res) => {
        if (props.fire == false) {
          enqueueSnackbar("مرحله دوم با موفقیت تکمیل شد", {
            variant: "success",
            autoHideDuration: 2000,
          });
          props.setExpanded("panel3");
        }

        props.fill(level2);
      },
      props.setFire
    );
  }
}
